import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScPopoverComponent } from './sc-popover.component';
import { ScPopoverService } from './sc-popover.service';
import {
  ScDynamicOverlay,
  ScDynamicOverlayContainer
} from './sc-overlay-container';

@NgModule({
  declarations: [ScPopoverComponent],
  imports: [CommonModule, OverlayModule, PortalModule],
  providers: [ScPopoverService, ScDynamicOverlay, ScDynamicOverlayContainer],
  entryComponents: [ScPopoverComponent],
  exports: [ScPopoverComponent]
})
export class ScPopoverModule {}
